import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { BaseComponent } from '../classes/BaseComponent';
import { AuthenticationService } from '../authentication.service';
import { Global } from '../classes/Global';
import { StorageHelper } from '../helpers/StorageHelper';
import { ValidationHelper } from '../helpers/ValidationHelper';
import { BaseService } from '../classes/BaseService';
import { Log } from '../helpers/Log';

@Component({
  selector: 'app-change-username',
  templateUrl: './change-username.component.html',
  styleUrls: ['./change-username.component.scss'],
  providers: [ AuthenticationService ]
})
export class ChangeUsernameComponent extends BaseComponent implements OnInit {

  username: string = "";

  invalidUsername: boolean = false;
  invalidUsernameMessage: string = "";
  usernameChangeSuccess: boolean = false;
  serverError: boolean = false;
  serverMessage: string = "";

  @Output() onAuthFail = new EventEmitter();
  @Output() close = new EventEmitter();

  constructor(private authenticationService: AuthenticationService) {
    super();
  }

  ngOnInit() {
  }

  onUsernameChange(username) {
    this.username = username;
  }

  changeUsername() {

    this.serverError = false;
    this.usernameChangeSuccess = false;
    this.invalidUsername = false;
    this.invalidUsernameMessage = "";

    if(!ValidationHelper.isValidString(this.username)){
      this.invalidUsername = true;
      this.invalidUsernameMessage = this.getString("invalidUsername");
      return;
    }

    // Check if username consists only of underscores
    if(this.username.replace(/_/g, "").length === 0){
      this.invalidUsername = true;
      this.invalidUsernameMessage = this.getString("invalidUsernameFormat");
      return;
    }

    if(!ValidationHelper.isValidUsername(this.username) || !ValidationHelper.isValidUsernameFormat(this.username)){
      this.invalidUsername = true;
      this.invalidUsernameMessage = this.getString("invalidUsernameFormat");
      return;
    }

    this.authenticationService.changeUsername(Global.getCountry(),
    StorageHelper.getInstance().get(StorageHelper.keys.sessionToken), this.username).subscribe(res => {
      if(res && res["status"] == "success") {
        // Update username in localStorage
        StorageHelper.getInstance().save(StorageHelper.keys.username, this.username);
        // Automatically close and return to account settings
        this.close.emit();
      }
      else if(res && res["message"] == BaseService.COULDNT_LOAD_USER) {
        StorageHelper.getInstance().clear(StorageHelper.keys.sessionToken);
        this.onAuthFail.emit();
      }
      else {
        this.serverError = true;
        if(res && res["status"] == "error") {
          this.serverMessage = this.getString("usernameChangeError");
        } else {
          this.serverMessage = res && res["message"] ? res["message"] : "";
        }
      }

    }, err => {
      Log.getInstance().d(err);
    });
  }

}
